<div class="model-content-body">
  <ng-content></ng-content>
</div>
